module.exports = __webpack_public_path__ + "static/media/login-background.ae43e228.png";